import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VmeCommonModule } from '../../vme-common.module';
import { VMEComponentsModule } from '../../vme-components.module';
import { VmeDirectivesModule } from '../../vme-directives.module';
import { VmePipesModule } from '../../vme-pipes.module';
import { CustomTaskActionsComponent } from './manage-task-custom-action.component';

const routes: Routes = [
  {
    path: '',
    component: CustomTaskActionsComponent,
    data: { title: 'Manage Custom Task Actions' },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ManageTaskCustomActionRoutingModule {}

@NgModule({
  imports: [
    ManageTaskCustomActionRoutingModule,
    VmeCommonModule,
    VmeDirectivesModule,
    VmePipesModule,
    VMEComponentsModule,
  ],
  declarations: [CustomTaskActionsComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ManageTaskCustomActionModule {}
